"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AperturaSobre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="sobre-apertura" id="apertura-sobre" className="bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-normal text-foreground leading-[1.05] mb-12">
            Fulcro es un departamento fraccional de tecnología.
          </h1>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-3xl">
            <p>
              Trabajamos como brazo técnico externo de PyMEs y operaciones medianas que necesitan escalar sin contratar un equipo de tecnología in-house. Diagnosticamos operaciones, diseñamos la arquitectura correcta, construimos la implementación y la mantenemos viva en el tiempo.
            </p>

            <p className="text-foreground/80 italic">
              No somos agencia. No somos freelancers. No somos software-as-a-service. Somos la categoría intermedia que la mayoría de las PyMEs mexicanas todavía no sabe que existe.
            </p>
          </div>
        </div>
      </div>
    </section>;
}